









































































































































































































































































































































import { Component, Prop, Watch, PropSync, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import { CorrectionsApi, TanksApi } from '@/api';
import TankChartAdmin from '@/components/charts/tank-chart.vue';
import DataTable from '@/components/datatable.vue';
import Toast from '@/components/display/toast.vue';
import TitleMixin from '@/mixins/title-mixin';
import routerLinkButton from '@/components/elements/buttons/router-link-button.vue';
import { FuelTankVolumeCalculator, TankHeightVolume } from '@/typings/fuel-volume-calculator.ts';
import TooltipButton from './elements/buttons/tooltip-button.vue';
import { getOtherActionText } from '@/common/HelpTextUtils';

@Component({
	components: {
		routerLinkButton,
		secondaryNav,
		TankChartAdmin,
		DataTable,
		Toast,
		TooltipButton,
	},
	mixins: [TitleMixin],
	methods: {
		getOtherActionText,
		rowDataRowClass(item, type) {
			if (
				item != undefined &&
				item.data != undefined &&
				item.data.faultName != undefined &&
				item.data.faultName.length > 1
			) {
				return 'table-secondary';
			}
			return '';
		},
	},
})
export default class FuelCorrections extends Vue {
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public series = 'volume';

	public checkedDips = [];
	public checkedRawData = [];

	public correctionFields = [];
	public editDipRefillForm = { notes: '', amount: '', correctionType: '' };
	public addDipRefillForm = { notes: '', amount: '', correctionType: 'dipHeight' };

	// public calculatedTank: Promise<TankHeightVolume | Error> = {volume: 0, maxVolume: 0, minVolume: 0, height: 0};

	public next = '';
	public prev = '';
	public savedDips = [];
	public rawData = [];
	public correction: any | null = null;
	public parameters: any | null = null;

	get state() {
		return this.series === 'volume'
			? this.checkedRawData.length === 1
			: this.checkedRawData.length >= 1;
	}

	@PropSync('tank')
	public localTank!: object;

	@PropSync('calculatedTank')
	public localCalculatedTank!: Promise<TankHeightVolume | Error>;

	public correctionState = true;
	public refillRawDataFields = [
		{ key: 'sel', label: '' },
		{ key: 'date', label: 'Date' },
		{ key: 'data.startCapacitance', label: 'Start pF' },
		{ key: 'data.endCapacitance', label: 'End pF' },
		{ key: 'data.startVolume', label: 'Start Volume' },
		{ key: 'data.endVolume', label: 'End Volume' },
		{ key: 'data.val', label: 'Refill Volume' },
		{ key: 'data.eventType', label: 'Event Type' },
	];

	public volumeRawDataFields = [
		{ key: 'sel', label: '' },
		{ key: 'receivedDate', label: 'Received' },
		{ key: 'date', label: 'Reading date' },
		{ key: 'data.capacitance', label: 'pF' },
		{ key: 'data.height', label: 'Height in mm' },
		{ key: 'data.val', label: 'L in Tank' },
		{ key: 'data.faultName', label: 'Fault' },
	];

	public fuelCorrectionFields = [
		{ key: 'sel', label: '' },
		{ key: 'readingTime', label: 'Date' },
		{ key: 'correctionType', label: 'Type' },
		{ key: 'levnoAmount', label: 'Sensor Reading' },
		{ key: 'amount', label: 'Actual Reading' },
		{ key: 'diff', label: 'Dip Difference' },
		{ key: 'notes', label: 'Notes' },
		{ key: 'user.name', label: 'By' },
	];

	public smallScreen = window.innerWidth;

	public async setDipRefillList() {
		this.savedDips = [];
		const sortedCorrections = this.localTank.corrections.sort((a: any, b: any) =>
			new Date(a.readingTime).getTime() < new Date(b.readingTime).getTime() ? 1 : -1,
		);
		for (const dipRefill of sortedCorrections) {
			dipRefill.checked = false;
			if (dipRefill.correctionType === 'dipHeight') {
				const temp = await this.calculateTankVolume(dipRefill.capacitance);
				dipRefill.levnoAmount = temp.height || null;
				dipRefill.dipHeightVolume = temp.volume || null;
			} else if (dipRefill.correctionType === 'dipVolume') {
				const temp = await this.calculateTankVolume(dipRefill.capacitance);
				dipRefill.levnoAmount = temp.volume || null;
			} else if (dipRefill.correctionType === 'refill') {
				const temp = await this.calculateTankVolume(dipRefill.startCapacitance);
				const temp2 = await this.calculateTankVolume(dipRefill.endCapacitance);
				dipRefill.levnoAmount = temp2.volume - temp.volume;
			}
			this.savedDips.push(dipRefill);
		}
		this.localCalculatedTank = await this.calculateTankVolume();
	}

	// calculate levno Amount from fuel volume calculator
	public async calculateTankVolume(passCapacitance?: number | undefined) {
		try {
			return await FuelTankVolumeCalculator.calculate(
				passCapacitance || 9999999, // mod
				this.localTank.formula.formula,
				this.localTank.formula.name,
				this.localTank.id,
				this.parameters,
				this.correction, // mod
				this.localTank.sensor.probeLength,
				this.localTank.sensor.emptyCapacitance,
				this.localTank.dielectric.fluidDielectric,
				this.localTank.dielectric.dielectric,
			);
		} catch (e) {
			console.log(e);
		}
	}

	public created() {
		this.loadData();
		window.addEventListener('resize', this.myEventHandler);
	}
	public destroyed() {
		window.removeEventListener('resize', this.myEventHandler);
	}
	public myEventHandler(e) {
		this.smallScreen = e.target.innerWidth;
	}

	public async loadData() {
		this.submitStatus = 'PENDING';
		await this.$parent.$parent.$parent.loadTank();
		if (this.localTank.formulaId) {
			this.setCorrectionFields();
		}
		this.parameters = this.localTank.parameters;
		if (!this.localTank.correction) {
			// if no correction object use fields from set correctionFields and set the values to 0
			this.correction = {};
			this.correctionFields.forEach(cf => (this.correction[cf.name] = 0));
		} else {
			this.correction = { ...this.localTank.correction };
		}
		this.setDipRefillList();
		this.setRawData();
		this.submitStatus = 'OK';
	}

	// only need to do on load
	public setCorrectionFields() {
		// set base from formula
		const params = this.localTank.formula.inputs.replace(/(\r\n|\n|\r)/g, '\\n').split('\\n');
		this.correctionFields = [];
		params.forEach(row => {
			const [type, name, label, paramStr] = row.split('|');
			this.correctionFields.push({ type, name, label, parameters: paramStr.split(',') });
		});
	}

	// delete all selected Dips notes
	public async deleteSelectedDipRefills() {
		try {
			await Promise.all(
				this.checkedDips.map(async correction => {
					await this.deleteDipRefill(correction.id);
				}),
			);
		} catch (e) {
			console.log(e);
		}
		this.checkedDips = [];
		await this.loadData();
		new Toast().makeToast('Successfully Deleted Dips', 'Successful Deletion of Dips', 'success');
	}

	public async deleteDipRefill(correctionId) {
		try {
			const response = await new CorrectionsApi().deleteCorrection(parseInt(correctionId, 10));
		} catch (e) {
			const error = e.response.data.errors.name[0];
			new Toast().makeToast(error, 'Error Deleting Fuel Dip', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}
	}

	// open correction modal - eg edit correction note
	public editDipRefill() {
		this.editDipRefillForm.notes = this.checkedDips[0].notes;
		this.editDipRefillForm.amount = this.checkedDips[0].amount;
	}

	// save edit from correction model
	public async updateCorrection(e: Event) {
		// e.preventDefault();
		let fuelCorrection = {};
		fuelCorrection = this.checkedDips[0];
		fuelCorrection.notes = this.editDipRefillForm.notes;
		fuelCorrection.amount = this.editDipRefillForm.amount;
		// update
		try {
			const response = await new CorrectionsApi().updateCorrection(fuelCorrection.id, {
				data: fuelCorrection,
			});
		} catch (e) {
			let error;
			if (e.response) {
				error = 'Error Updating Fuel Correction ' + e.response.data.message;
			} else if (e.request) {
				error = 'Error Updating Fuel Correction, network Error';
			} else {
				error = 'Error Updating Fuel Correction';
			}
			new Toast().makeToast(error, 'Error Updating Fuel Correction', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}

		this.checkedDips = [];
		await this.loadData();
		new Toast().makeToast(
			'Successfully Edited Correction Note',
			'Successful Edit of Note',
			'success',
		);
	}

	// update offset based on levnoAmount - amount
	public async matchCorrection() {
		this.correction.offset -= this.checkedDips[0].levnoAmount - this.checkedDips[0].amount;
		this.matchOffset();
		this.checkedDips = [];
	}

	// load fuel_correction (eg a correction note)
	public async addToDipRefillList(e: Event) {
		// e.preventDefault();
		e.preventDefault();
		// refill sort checkedRawData array by timestamp
		this.checkedRawData.sort((a, b) => (b.date < a.date ? 1 : -1));
		const rawDatalength = this.checkedRawData.length - 1;
		const fuelCorrection = {
			tankId: this.localTank.id,
			fuelType: this.localTank.fuelType,
			correctionType: this.addDipRefillForm.correctionType,
			amount: this.addDipRefillForm.amount,
			notes: this.addDipRefillForm.notes,
			levnoAmount: 0,
			capacitance: this.checkedRawData[0].data.capacitance,
			endCapacitance: 0,
			startHeight: 0,
			endHeight: 0,
			readingTime: this.checkedRawData[0].data.timestamp,
			lastReadingTime: '',
			createdAt: '',
		};
		if (['dipHeight', 'dipVolume'].includes(this.addDipRefillForm.correctionType)) {
			const dipCalculation = await this.calculateTankVolume(
				this.checkedRawData[0].data.capacitance,
			);
			fuelCorrection.levnoAmount =
				this.addDipRefillForm.correctionType === 'dipHeight'
					? dipCalculation.height
					: dipCalculation.volume;
		} else if (this.addDipRefillForm.correctionType === 'refill') {
			const refillStartCalculation = await this.calculateTankVolume(
				this.checkedRawData[0].data.startCapacitance,
			);
			const refillEndCalculation = await this.calculateTankVolume(
				this.checkedRawData[rawDatalength].data.endCapacitance,
			);
			fuelCorrection.levnoAmount = refillEndCalculation.volume - refillStartCalculation.volume;
			fuelCorrection.startCapacitance = this.checkedRawData[0].data.startCapacitance;
			fuelCorrection.endCapacitance = this.checkedRawData[rawDatalength].data.endCapacitance;
			fuelCorrection.startHeight = parseInt(this.checkedRawData[0].data.startHeight, 10);
			fuelCorrection.endHeight = parseInt(this.checkedRawData[rawDatalength].data.endHeight, 10);
			fuelCorrection.readingTime = this.checkedRawData[0].data.timestamp;
			fuelCorrection.lastReadingTime = this.checkedRawData[rawDatalength].data.timestamp;
		}
		try {
			const response = await new CorrectionsApi().addCorrection({ data: fuelCorrection });
			await this.$parent.$parent.$parent.loadTank();
		} catch (e) {
			let error;
			if (e.response) {
				error = 'Error Adding Fuel Correction ' + e.response.data.message;
			} else if (e.request) {
				error = 'Error Adding Fuel Correction, network Error';
			} else {
				error = 'Error Adding Fuel Correction';
			}
			new Toast().makeToast(error, 'Error Making Fuel Correction Note', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}

		this.checkedRawData = [];
		this.addDipRefillForm.correctionType = 'dipHeight';
		this.addDipRefillForm.notes = '';
		this.addDipRefillForm.amount = '';
		this.setDipRefillList();
		this.setRawData();
		new Toast().makeToast('Successfully Add Tank Correction Note', 'Successful Note', 'success');
	}

	// Load Tank Correction Parameters
	public async matchOffset() {
		const tankId = this.localTank.id;
		const tank = {
			id: tankId,
			productId: this.localTank.productId,
			correction: { ...this.localTank.correction, offset: this.correction.offset },
		};
		try {
			const response = await new TanksApi().updateTank(parseInt(tankId, 10), { data: tank });
			await this.loadData();
		} catch (e) {
			let error;
			if (e.response) {
				error = 'Error Adding Tank Correction ' + e.response.data.message;
			} else if (e.request) {
				error = 'Error Adding Tank Correction, network Error';
			} else {
				error = 'Error Adding Correction';
			}
			new Toast().makeToast(error, 'Error Making Correction', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}
		new Toast().makeToast(
			'Successfully Updated Tank Correction',
			'Successful Correction',
			'success',
		);
	}

	// Update Tank Correction Parameters
	public async updateTankCorrections() {
		const tankId = this.localTank.id;
		const tank = { id: tankId, productId: this.localTank.productId, correction: this.correction };
		try {
			const response = await new TanksApi().updateTank(parseInt(tankId, 10), { data: tank });
			await this.loadData();
		} catch (e) {
			let error;
			if (e.response) {
				error = 'Error Adding Tank Correction ' + e.response.data.message;
			} else if (e.request) {
				error = 'Error Adding Tank Correction, network Error';
			} else {
				error = 'Error Adding Correction';
			}
			new Toast().makeToast(error, 'Error Making Correction', 'danger', true);
			return;
		}

		new Toast().makeToast(
			'Successfully Updated Tank Correction',
			'Successful Correction',
			'success',
		);
		this.loadData();
	}

	public async setRawData() {
		if (this.addDipRefillForm.correctionType === 'dipVolume') {
			this.series = 'receivedVolume';
		} else if (this.addDipRefillForm.correctionType === 'dipHeight') {
			this.series = 'receivedVolume';
		} else if (this.addDipRefillForm.correctionType === 'refill') {
			this.series = 'refill';
		}
		this.checkedRawData = [];
		this.addDipRefillForm.amount = '';
		this.reloadData(null, null);
	}

	public async reloadData(sortKey: string, prev = false) {
		const tankId = this.localTank.id;
		try {
			const api = new TanksApi();
			const response = await api.getTankVolumeData(parseInt(tankId, 10), this.series, {
				params: { perPage: 5, page: 1, sortKey, prev },
			});
			this.rawData = response.data.data.sort((a, b) =>
				new Date(b.date ?? '') > new Date(a.date ?? '') ? 1 : -1,
			);
			this.next = response.data.links.nextSort;
			this.prev = response.data.links.currentSortKey;
		} catch (e) {
			console.log(e);
		}
	}

	public async back() {
		this.reloadData(this.prev, true);
	}

	public async forward() {
		this.reloadData(this.next, false);
	}
}
